import Vue from 'vue'
import Vuex from 'vuex'

// default router permission control
// import permission from './modules/permission'

// dynamic router permission control (Experimental)

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
